// Axios
import axios from 'axios';

// Endpoints
import { ENDPOINTS_POST, ENDPOINTS_PUT, ENDPOINTS_GET, ENDPOINTS_DELETE } from '@/app/apis/auth/_connection/auth-connection-endpoints.js';

// Interceptor
import { authApiInterceptor } from '@/app/apis/auth/_connection/auth-connection-interceptors.js';

// API Instance
export const authInstance = axios.create({
	baseURL: `${process.env.VUE_APP_AUTH_SERVICE_BASE_URL}/${process.env.VUE_APP_AUTH_SERVICE_API_KEY}`,
	headers: {},
	timeout: 20000, // 20 seconds
	validateStatus: status => {
		return status;
	},
});

// Interceptor
authApiInterceptor(authInstance);

// API Methods
export const AUTH = {
	post(endpoint, formData) {
		return authInstance.post(endpoint, formData);
	},
	put(endpoint, formData) {
		return authInstance.put(endpoint, formData);
	},
	get(endpoint) {
		return authInstance.get(endpoint);
	},
	delete(endpoint) {
		return authInstance.delete(endpoint);
	}
}

// API Endpoints
export const AUTH_ENDPOINTS = {
	...ENDPOINTS_POST,
	...ENDPOINTS_PUT,
	...ENDPOINTS_GET,
	...ENDPOINTS_DELETE
}